import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import CreateOrEdit from "./from";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";
import CommomApproval from "../../../utils/CommomApproval";

function MasterListOfDocumentIndex() {
  const ModelId = 4;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let { statusFilter } = location?.state || "";
  let value = {
    status:statusFilter||""
  }
  const { statusValue } = useGetStatusData({ value: ModelId });
  const {
    completePercentage,
    getData: getDashboardData,
    isReveiw,
  } = useDashboardStatus({
    url: `/DashBoard/standard/${stdId}/master_list_of_document/`,
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: statusFilter
      ? `/Master-List-Of-Document/standard/${stdId}/`
      : `/Master-List-Of-Document/standard/${stdId}/`,
    page: pageIndex,
    pageCount: dataCount,
    param:value
  });
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleApprovalOnClose = () => setShowApprovalModal(false);

  async function clearFilter() {
    value={
      status:""
    }
    navigate(".", { replace: true, state: { statusFilter: null } });
    await getData(true);
  }

  return (
    <>
      <ViewTableIndex
        label="Master List Of Document"
        menu="Activity"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="activity_create"
        hasOverAll={true}
        OverAllPercentage={completePercentage}
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={() => setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={() => setShowImport(true)}
        hasImport={true}
        hasFilter={true}
        filterValue={statusFilter}
        clearFunction={clearFilter}
        hasApprove={true}
        ReviewStatus={isReveiw}
        ReviewFunction={() => setShowApprovalModal(true)}
      >
        <>
          {data &&
            data?.map((data, i) => (
              <tr
                className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                key={i}
              >
                <td className="px-2 py-1 text-gray-900 whitespace-nowrap text-center w-[5%] capitalize">
                  {data.serial_number || "#"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[22%] capitalize ">
                  {data?.document_name || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[25%] capitalize ">
                  {data?.document_description || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.version || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[15%] capitalize ">
                  {data?.latest_update && (NuDateFormat({
                              value: data?.latest_update,
                              format: "DD-MMM-yyyy",
                            })) || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.status || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize flex justify-center items-center">
                  {data?.image_path?.length > 0 && <PaperClip />}
                </td>
                <td className="px-2 py-1 w-[3%] flex justify-center items-center">
                  <ViewMore
                    data={data}
                    satusData={statusValue}
                    fetcher={getData}
                    getCompletion={getDashboardData}
                    id={stdId}
                  />
                </td>
              </tr>
            ))}
        </>
      </ViewTableIndex>
      <CreateOrEdit
        visible={showMyModal}
        onClose={handleOnClose}
        refreshData={getData}
        satusData={statusValue}
        getCompletion={getDashboardData}
        id={stdId}
      />
      <CommonXlsExport
        id={stdId}
        path={`master_list_of_document`}
        name={`${standardDetailName} Master List Of Document ${
          standardStartDate &&
          NuDateFormat({ value: standardStartDate, format: "MMM-YYYY" })
        } ${standardEndDate && "to"} ${
          standardEndDate &&
          NuDateFormat({ value: standardEndDate, format: "MMM-YYYY" })
        }`}
        visible={showExport}
        onClose={() => {
          setShowExport(false);
        }}
      />

      <CommonImport
        url={`/Master-List-Of-Document/standard/${stdId}/Import`}
        refreshData={getData}
        getFuction={getDashboardData}
        visible={showImport}
        onClose={() => setShowImport(false)}
        hasRemoveApproval={true}
        moduleId={ModelId}
        standardId={stdId}
      />

      <CommomApproval
        visible={showApprovalModal}
        onClose={handleApprovalOnClose}
        refreshData={getData}
        moduleId={ModelId}
        id={stdId}
        moduleName="Master List Of Document"
        standardName={standardDetailName}
        getCompletion={getDashboardData}
      />
    </>
  );
}

export default MasterListOfDocumentIndex;

const header = [
  {
    headone: <span>Sl&nbsp;No.</span>,
    width: "w-[5%]",
  },
  {
    headone: "Document Name",
    width: "w-[22%]",
  },
  {
    headone: "Document Description",
    width: "w-[25%]",
  },
  {
    headone: "Version",
    width: "w-[10%]",
  },
  {
    headone: "Latest Updated",
    width: "w-[15%]",
  },
  {
    headone: "Status",
    width: "w-[10%]",
  },
  {
    headone: "Artefact",
    width: "w-[10%]",
  },
  {
    headone: "",
    width: "w-[3%]",

  },
];
